import "./loading.css";

const Loading = () => {
  return <span className="loading">loading...</span>;
};

export default Loading;
